import { Badge } from "@/components/ui/badge";
import { IdCard, Shield, UserCog } from "lucide-react";
import { UserType } from "@/types/unified-user";

interface UserTypeBadgeProps {
  type: UserType;
  showIcon?: boolean;
}

export function UserTypeBadge({ type, showIcon = true }: UserTypeBadgeProps) {
  const config = {
    directory: {
      label: "Directory",
      icon: IdCard,
      variant: "secondary" as const,
      className: "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300",
    },
    console: {
      label: "Console",
      icon: Shield,
      variant: "secondary" as const,
      className: "bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300",
    },
    both: {
      label: "Both",
      icon: UserCog,
      variant: "secondary" as const,
      className: "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300",
    },
  };

  const { label, icon: Icon, variant, className } = config[type];

  return (
    <Badge variant={variant} className={className}>
      {showIcon && <Icon className="w-3 h-3 mr-1" />}
      {label}
    </Badge>
  );
}
